declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

let isInitialized = false
let measurementId: string | undefined

const getMeasurementId = (): string | undefined => {
  if (measurementId) {
    return measurementId
  }

  const id = process.env.REACT_APP_GA_MEASUREMENT_ID

  if (!id) {
    return undefined
  }

  measurementId = id
  return measurementId
}

export const initAnalytics = (): void => {
  if (isInitialized) {
    return
  }

  if (process.env.NODE_ENV !== 'production') {
    return
  }

  const id = getMeasurementId()

  if (!id) {
    return
  }

  if (typeof window === 'undefined') {
    return
  }

  if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${id}"]`)) {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
    document.head.appendChild(script)
  }

  window.dataLayer = window.dataLayer || []
  if (!window.gtag) {
    window.gtag = (...args: unknown[]) => {
      if (!window.dataLayer) {
        window.dataLayer = []
      }

      window.dataLayer.push(args)
    }
  }

  window.gtag('js', new Date())
  window.gtag('config', id, { send_page_view: false })

  isInitialized = true
}

export const trackPageView = (path: string): void => {
  if (!isInitialized) {
    return
  }

  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return
  }

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  })
}

export {}

